import { CSSProperties, ReactNode } from "react";
import classNames from "classnames";
import { MandatoryMarker } from "@/components/forms/inputs/mandatoryMarker";
import styles from "@/components/forms/inputs/formFieldLabel.module.css";

interface FormFieldLabelProps {
  label: ReactNode;
  htmlFor: string;
  mandatory?: boolean;
  className?: string;
  style?: CSSProperties;
  additionalContent?: ReactNode;
}

export const FormFieldLabel = ({
  label,
  htmlFor,
  mandatory,
  className,
  style,
  additionalContent,
}: FormFieldLabelProps) => (
  <label
    htmlFor={htmlFor}
    className={classNames(styles.label, className)}
    style={style}
  >
    <span className={styles.labelWrapper}>
      <span>
        {label}
        {mandatory && <MandatoryMarker />}
      </span>
      {additionalContent}
    </span>
  </label>
);
